// ISC License
// Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
// Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

import { useState, useEffect } from 'react';
import foto from 'url:./../olga_fedyszyn_olszewska.png';

const About = ({ id }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.1 }
        );

        const target = document.getElementById('about');
        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) observer.unobserve(target);
        };
    }, []);

    const contentClasses = `transition-all duration-1000 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`;
    const imageClasses = `transition-all duration-1000 ease-out transform ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`;

    return (
        <section id="about" className="py-20 px-4 md:px-12 bg-gray-50">
            <div className="max-w-7xl mx-auto">
                <h2 className="text-4xl font-extrabold text-[#1B5125] sm:text-5xl tracking-tight mb-12">
                    O Kancelarii
                </h2>

                {/* <div className="md:flex md:space-x-12 items-center">
                    <div className="md:w-1/3 mb-10 md:mb-0 flex-shrink-0">
                        <div className="text-center p-6 max-w-4xl relative z-10 flex flex-col items-center">
                            <img
                                src={foto}
                                alt="Adwokat Olga Fedyszyn-Olszewska"
                                className="max-h-[50vh] sm:max-h-[400px] lg:max-h-[500px] h-auto w-auto max-w-full mx-auto animate-fadeInUp mb-6"
                                style={{ animationDelay: '0.1s' }}
                            />
                        </div>
                    </div>

                    <div className={`text-lg text-gray-600 leading-relaxed ${contentClasses}`}>
                        <p className="mb-4">
                            Jestem absolwentką Wydziału Prawa i Administracji Uniwersytetu Łódzkiego. Aplikację adwokacką odbyłam przy Okręgowej Radzie Adwokackiej w Łodzi, gdzie po trzyletnim okresie szkoleniowym zdałam egzamin zawodowy i uzyskałam tytuł adwokata. W 2022 roku ukończyłam także Podyplomowe Studium Prawa Medycznego, Bioetyki i Socjologii Medycyny na Uniwersytecie Warszawskim.
                        </p>
                        <p className="mb-4 font-semibold text-gray-700">
                            Od ponad sześciu lat aktywnie rozwijam praktykę zawodową w swoich specjalizacjach, co pozwala mi świadczyć rzetelną, uważną i kompleksową pomoc prawną, zarówno osobom prywatnym, jak i przedsiębiorcom. Do każdej sprawy podchodzę indywidualnie, z pełnym zaangażowaniem, dbając o najwyższy poziom merytoryczny i realną efektywność podejmowanych działań. Interesy moich Klientów reprezentuję z najwyższą starannością na każdym etapie sprawy, począwszy od rozmów negocjacyjnych, po postępowania przed organami oraz sądami wszystkich instancji.
                        </p>
                        <p>
                            W centrum moich zainteresowań oraz doświadczeń znajdują się przede wszystkim prawo cywilne, prawo rodzinne, prawo handlowe i gospodarcze oraz prawo medyczne. Praca w tych dziedzinach wymaga nie tylko wysokiej staranności i profesjonalizmu, lecz także empatii, uważności i umiejętności prowadzenia konstruktywnego dialogu, a więc wartości, które są dla mnie szczególnie ważne we współpracy z Klientami.
                        </p>
                        <p>
                            Siedziba Kancelarii znajduje się w Łodzi, jednakże wychodząc naprzeciw potrzebom oraz oczekiwaniom Klientów, świadczę również usługi prawne w formie zdalnej.
                        </p>
                    </div>
                </div> */}
                <div className={`text-lg text-gray-600 leading-relaxed ${contentClasses}`}>
                    <p className="mb-4">
                        Jestem absolwentką Wydziału Prawa i Administracji Uniwersytetu Łódzkiego. Aplikację adwokacką odbyłam przy Okręgowej Radzie Adwokackiej w Łodzi, gdzie po trzyletnim okresie szkoleniowym zdałam egzamin zawodowy i uzyskałam tytuł adwokata. W 2022 roku ukończyłam także Podyplomowe Studium Prawa Medycznego, Bioetyki i Socjologii Medycyny na Uniwersytecie Warszawskim.
                    </p>
                    <p className="mb-4 font-semibold text-gray-700">
                        Od ponad sześciu lat aktywnie rozwijam praktykę zawodową w swoich specjalizacjach, co pozwala mi świadczyć rzetelną, uważną i kompleksową pomoc prawną, zarówno osobom prywatnym, jak i przedsiębiorcom. Do każdej sprawy podchodzę indywidualnie, z pełnym zaangażowaniem, dbając o najwyższy poziom merytoryczny i realną efektywność podejmowanych działań. Interesy moich Klientów reprezentuję z najwyższą starannością na każdym etapie sprawy, począwszy od rozmów negocjacyjnych, po postępowania przed organami oraz sądami wszystkich instancji.
                    </p>
                    <p>
                        W centrum moich zainteresowań oraz doświadczeń znajdują się przede wszystkim prawo cywilne, prawo rodzinne, prawo handlowe i gospodarcze oraz prawo medyczne. Praca w tych dziedzinach wymaga nie tylko wysokiej staranności i profesjonalizmu, lecz także empatii, uważności i umiejętności prowadzenia konstruktywnego dialogu, a więc wartości, które są dla mnie szczególnie ważne we współpracy z Klientami.
                    </p>
                    <p>
                        Siedziba Kancelarii znajduje się w Łodzi, jednakże wychodząc naprzeciw potrzebom oraz oczekiwaniom Klientów, świadczę również usługi prawne w formie zdalnej.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default About;
